export default {
  manningVessels: {},
  latestCutoffDate: null,
  enterpriseCrews: [],
};
